import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const Impact = () => {
  const stats = [
    { value: '10,000+', description: 'Samples Tracked' },
    { value: '200+', description: 'Mosquito Traps Monitored' },
    { value: '10+', description: 'Publications & Studies' },
    { value: '2', description: 'Major Partnerships' },
    {value: '10+', description: 'Digital Platforms Developed' },
  ];

  const testimonials = [
    {
      quote: 'The mosquito tracking app has revolutionized vector-borne disease surveillance.',
      author: 'Charles Ragot, Entomologist',
      image: '/images/dr-jane-mwangi.jpg',
    },
    {
      quote: 'Customized SORMAS enabled faster dengue outbreak detection.',
      author: 'Dr. Ferdinard Adungo, Principal Research Scientist',
      image: '/images/team-member1.jpg',
    },
    {
      quote: 'EpiTech simplified enrollment and data management.',
      author: 'Benard Oluoch, Research Scientist',
      image: '/images/team-member2.jpg',
    },
  ];

  return (
    <section id="impact" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-12 text-blue-800">Our Impact</h2>
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-12">
          {stats.map((stat, index) => (
            <div key={index} className="text-center p-4 bg-gray-50 rounded-xl shadow-md">
              <h3 className="text-4xl font-bold text-teal-500">{stat.value}</h3>
              <p className="text-gray-600">{stat.description}</p>
            </div>
          ))}
        </div>
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={30}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 5000 }}
          loop
          className="max-w-3xl mx-auto"
        >
          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={index}>
              <div className="text-center p-6 border-l-4 border-teal-500 bg-gray-50 rounded-xl shadow-md">
                <img
                  src={testimonial.image}
                  alt={testimonial.author}
                  className="w-16 h-16 rounded-full mx-auto mb-4 object-cover"
                  loading="lazy"
                />
                <blockquote className="italic text-gray-600 mb-2">“{testimonial.quote}”</blockquote>
                <p className="text-gray-800 font-semibold">{testimonial.author}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Impact;